import React from "react";
import {Button, Card, CardContent, Chip, Divider, Stack, Typography} from "@mui/material";
import {Link as RouterLink} from "react-router-dom";
import ContextTooltip from "../../shared/ContextTooltip";

export default function DashboardQuickLinks({hasAccounting, invoices, openInvoices, overdueInvoices}) {
    return (
        <Card sx={{borderRadius: 3, height: "100%", boxShadow: "0 6px 24px rgba(0,0,0,0.06)"}}>
            <CardContent>
                <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography variant="h6">Schnellzugriff</Typography>
                    <ContextTooltip
                        title="Schnellzugriff"
                        description="Direkte Einstiegspunkte in Ihre wichtigsten Prozesse."
                    />
                </Stack>
                <Stack direction="row" flexWrap="wrap" gap={1.5} sx={{mt: 1}} className="no-drag">
                    <Button
                        component={RouterLink}
                        to="/invoices"
                        variant="contained"
                        sx={{bgcolor: "orange", "&:hover": {bgcolor: "#cc7a00"}, borderRadius: 2, color: "#000"}}
                    >
                        Rechnung erstellen
                    </Button>
                    {hasAccounting ? (
                        <>
                            <Button
                                component={RouterLink}
                                to="/incomes"
                                variant="contained"
                                sx={{
                                    bgcolor: "orange",
                                    "&:hover": {bgcolor: "#cc7a00"},
                                    borderRadius: 2,
                                    color: "#000",
                                }}
                            >
                                Einnahmen
                            </Button>
                            <Button
                                component={RouterLink}
                                to="/expenses"
                                variant="contained"
                                sx={{
                                    bgcolor: "orange",
                                    "&:hover": {bgcolor: "#cc7a00"},
                                    borderRadius: 2,
                                    color: "#000",
                                }}
                            >
                                Ausgaben
                            </Button>
                            <Button
                                component={RouterLink}
                                to="/evaluation"
                                variant="contained"
                                sx={{
                                    bgcolor: "orange",
                                    "&:hover": {bgcolor: "#cc7a00"},
                                    borderRadius: 2,
                                    color: "#000",
                                }}
                            >
                                Auswertung
                            </Button>
                        </>
                    ) : (
                        <Button
                            component={RouterLink}
                            to="/registration"
                            variant="contained"
                            sx={{
                                bgcolor: "orange",
                                "&:hover": {bgcolor: "#cc7a00"},
                                borderRadius: 2,
                                color: "#000",
                            }}
                        >
                            Buchhaltung freischalten
                        </Button>
                    )}
                    <Button
                        component={RouterLink}
                        to="/article"
                        variant="contained"
                        sx={{bgcolor: "orange", "&:hover": {bgcolor: "#cc7a00"}, borderRadius: 2, color: "#000"}}
                    >
                        Artikel
                    </Button>
                    <Button
                        component={RouterLink}
                        to="/orders"
                        variant="contained"
                        sx={{bgcolor: "orange", "&:hover": {bgcolor: "#cc7a00"}, borderRadius: 2, color: "#000"}}
                    >
                        Aufträge
                    </Button>
                </Stack>

                <Divider sx={{my: 2}}/>

                <Typography variant="body2" color="text.secondary" sx={{mb: 1}}>
                    Status
                </Typography>
                <Stack direction="row" gap={1} flexWrap="wrap" className="no-drag">
                    <Chip label={`Rechnungen: ${invoices.length}`} size="small"/>
                    <Chip label={`offen: ${openInvoices.length}`} size="small" color="warning"/>
                    <Chip label={`überfällig: ${overdueInvoices.length}`} size="small" color="error"/>
                </Stack>
            </CardContent>
        </Card>
    );
}
